const template = ({ title, location, glob }) =>
  `
    <li class="o-layout__item  u-1/3@small"
        ${glob ? `data-global=${glob}` : null}
    >
      <h4>${title}</h4>
      <p>${location}</p>
    </li>
  `

const addStockist = stockist => template(stockist)

const createTemplates = (stockists) => {
  document.querySelector('.js-stockists').innerHTML = stockists
    .map((stockist, index) => addStockist(stockist, index, stockists.length))
    .join('')
}

const enable = () => {
  if (window.stockistsJSON) {
    const { stockists } = window.stockistsJSON
    createTemplates(stockists)
  }
}

export default { enable }
